import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CTAStrip from '../../components/feature/CTAStrip';
import { useNavigate } from 'react-router-dom';

const industries = [
  {id:'ind-ecommerce',ico:'🛍',name:'Ecommerce',desc:'Built for DTC brands and online sellers who need fast, accurate fulfillment at scale.',tags:['Same-Day Dispatch','Returns Mgmt','Branded Packaging','API Integration']},
  {id:'ind-retail',ico:'🏪',name:'Retail',desc:'Reliable distribution to retail outlets, supermarkets, and multi-location chains.',tags:['Store Replenishment','Bulk Distribution','Cross-Docking']},
  {id:'ind-pharmaceuticals',ico:'💊',name:'Pharmaceuticals',desc:'Dry pharmaceutical storage and nationwide distribution with lot tracking, expiry management, and NAFDAC-compliant documentation.',tags:['Dry Storage','Lot Tracking','FEFO Picking','Audit Trail','Distribution']},
  {id:'ind-fashion',ico:'📸',name:'Fashion & Apparel',desc:'Garment handling, steaming, poly-bagging, visual QC, and efficient returns processing.',tags:['Garment Care','Visual QC','Returns Processing']},
  {id:'ind-fmcg',ico:'🥤',name:'FMCG',desc:'High-velocity throughput. Cross-docking, route-to-market distribution, bundle assembly.',tags:['High Throughput','Route-to-Market','Kitting']},
  {id:'ind-electronics',ico:'📱',name:'Electronics',desc:'Secure storage, serialized tracking, and careful handling. ESD-safe areas, insured handling.',tags:['Serialized Tracking','Secure Vault','ESD Safe']},
  {id:'ind-banks',ico:'🏦',name:'Banks & Fintech',desc:'POS terminal storage, secure distribution, and swap logistics for banks and fintech companies.',tags:['POS Distribution','Serialized Tracking','Secure Storage','Terminal Swap']},
  {id:'ind-renewable',ico:'☀',name:'Renewable Energy',desc:'Storage and last-mile distribution for solar panels, inverters, batteries, and clean energy equipment.',tags:['Solar Equipment','Oversized Cargo','Last-Mile Delivery Coordination','Inventory Mgmt']},
  {id:'ind-ngos',ico:'❤',name:'NGOs & Humanitarian',desc:'Reliable logistics for aid organisations and nonprofits with compliant documentation.',tags:['Aid Logistics','Donor Reporting','Chain of Custody','Compliant Docs']},
  {id:'ind-importers',ico:'🚜',name:'Importers & Distributors',desc:'End-to-end support from port collection through to nationwide retail distribution.',tags:['Container Handling','Customs Support','Nationwide Distrib.','Bulk Storage']},
];

export default function IndustriesPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-thl-dark">
      <Navbar />
      <div className="page-header pt-28 pb-16 px-6">
        <div className="page-header-grid" />
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-3 text-xs text-white/40">
            <button onClick={()=>navigate('/')} className="hover:text-white cursor-pointer">Home</button>
            <span>/</span><span className="text-white/60">Industries</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">Industries We Serve</h1>
          <p className="text-white/50 max-w-xl">THL's fulfillment infrastructure meets the unique requirements of diverse industries.</p>
        </div>
      </div>
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {industries.map(ind=>(
            <div id={ind.id} key={ind.name} className="bg-thl-dark3 border border-thl-border rounded-xl overflow-hidden hover:border-thl-red/30 transition-all">
              <div className="flex items-center gap-4 p-5 border-b border-thl-border">
                <div className="text-3xl">{ind.ico}</div>
                <h3 className="text-white font-bold text-base">{ind.name}</h3>
              </div>
              <div className="p-5">
                <p className="text-white/60 text-sm mb-4 leading-relaxed">{ind.desc}</p>
                <div className="flex flex-wrap gap-2">{ind.tags.map(t=><span key={t} className="tag">{t}</span>)}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <CTAStrip headline="Your Industry, Our Expertise" sub="Talk to a specialist who understands your sector's specific logistics requirements." btn1="Speak to a Specialist →" btn2="Book a Tour" btn2Path="/facilities" />
      <Footer />
    </div>
  );
}
